import React from 'react';
import {Stack} from '@mui/material';

import {DocumentItem} from '../DocumentItem';
import {DocumentListProps} from './types';

export function DocumentList({documents, fileName}: DocumentListProps) {
	return (
		<Stack gap={1}>
			{documents.map((item, index) => (
				<DocumentItem
					id={item.id}
					filename={`${fileName} ${index + 1}`}
					pathURL={item.url}
					key={item.id}
				/>
			))}
		</Stack>
	);
}
